import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { AccountEntities } from "../AccountEntities";

interface UserViewPageProps extends NSARouterMakerResult, AccountRouterProps
{ }

export default function UserViewPage(props: UserViewPageProps) 
{
	return (
		<AccountLayout {...props}
			pages={{
				entity: AccountEntities.user(props),
				ui: {
					action: {
						menus: {
							view_history: false
						}
					}
				},
				view: {
					ui: {
						tab_page_view: {
							enabled: true,
							tabs: {
								history: false
							}
						}
					}
				}
			}}
		>
			<></>
		</AccountLayout>
	);
};